module.exports = __webpack_public_path__ + "static/media/next.bb27dea8.svg";